import React, { useMemo, type ReactNode } from 'react';
import { useIntl } from '@atlassian/jira-intl';
import { EMPTY_SUMMARY } from '../../../common/constants/errors';
import type { FieldId } from '../../../common/constants/fields';
import type { MappingState } from '../../../common/types';
import messages from './messages';

const SUMMARY = 'summary';
const ISSUEID = 'issueId';

export const boldElement = (content: ReactNode) => <b>{content}</b>;

export const getMissingFieldName = (fieldId: FieldId, mappingState: MappingState) =>
	mappingState?.availableJiraFields
		.find((field) => field?.fieldId === fieldId)
		?.fieldName.toLowerCase() || fieldId;

export const useValidationErrors = (mappingState: MappingState | null) => {
	const { formatMessage } = useIntl();
	const columnErrorMap = mappingState?.validationError?.columnErrors || {};
	const missingFields = mappingState?.validationError?.missingFields || [];

	const missingErrorMap: Record<string, ReactNode> = useMemo(
		() => ({
			[SUMMARY]: formatMessage(messages.summaryMissing, { b: boldElement }),
			[ISSUEID]: formatMessage(messages.issueIdMissing, { b: boldElement }),
			[EMPTY_SUMMARY]: formatMessage(messages.emptySummary, { b: boldElement }),
		}),
		[formatMessage],
	);

	const missingErrors = missingFields.map((error) => missingErrorMap[error]);
	if (Object.values(columnErrorMap || []).includes(EMPTY_SUMMARY)) {
		missingErrors.push(missingErrorMap[EMPTY_SUMMARY]);
	}

	const columnErrors = Object.keys(columnErrorMap).filter(
		(key) => columnErrorMap[key] !== EMPTY_SUMMARY,
	);

	return {
		missingErrors,
		columnErrors,
		count: missingErrors.length + columnErrors.length,
	};
};
